import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Nav from 'react-bootstrap/Nav';
import { NavLink, useParams } from 'react-router-dom';
import { Outlet, useOutletContext } from 'react-router-dom';
import { usePageTitle } from 'routes/Util/Util.hooks';
import { StockContextType } from './StockPage';
import { GraphUpArrow, GraphDownArrow } from 'components/Icons';
import classNames from 'classnames';

type DirectionType = 'up' | 'down';

const OpinionListTitle = ({ direction }: { direction: DirectionType }) => {
  return (
    <Nav.Link as={NavLink} to={direction} href={direction} className="d-flex align-items-center text-secondary">
      {direction === 'down' ? <GraphDownArrow /> : <GraphUpArrow />}
      <span className={classNames('ms-2')}>{direction === 'down' ? '하락' : '상승'}</span>
    </Nav.Link>
  );
}

export const OpinionPage = () => {
  const { stock } = useOutletContext<StockContextType>();
  usePageTitle(`${stock.krShortName} 의견`);
  const { tab } = useParams();

  return (
    <>
      {/* TODO 디자인 개선  */}
      <Row className="mt-5">
        <Col className="d-lg-none">
          <Nav justify variant="tabs" defaultActiveKey={tab}>
            <Nav.Item>
              <OpinionListTitle direction="up" />
            </Nav.Item>
            <Nav.Item>
              <OpinionListTitle direction="down" />
            </Nav.Item>
          </Nav>
        </Col>
        <Col className="d-none d-lg-block">
          <OpinionListTitle direction="up" />
        </Col>
        <Col className="d-none d-lg-block">
          <OpinionListTitle direction="down" />
        </Col>
      </Row>
      <Outlet context={{ stock }} />
    </>
  );
}